// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MPZDMG3gFfolmNtn8DPI{align-items:center;display:flex}.IkHWYU2nmo9TuxLtTJCr{color:var(--content-primary-tertiary);margin-right:10px}.B9bw3jAvOV0wDn3RjQKW{color:var(--content-primary-primary);text-overflow:ellipsis;max-width:280px;overflow:hidden}.QQIs7Z_pgGR4_CjMyWko{align-items:center;display:flex}.wzxtStXdtQMIQb_kmMl0{color:var(--content-neutral-primary)}._uKC6eBPRggz6ui2_cDc{margin-top:6px}.BxbHM9wrsiIuNRsq3OsD{padding:2px}.x5D0hhrY0_hTi5l5FOpM{padding:10px}.gS7udETJ_AcjzWsEEsP1{color:var(--gray-60);justify-content:center;padding:8.5px 0;font-size:12px;font-weight:400;line-height:15px;display:flex}.wqG72rBtGGYfzuMJj4IP{align-items:center;display:flex}.ja7rU_DZj7gygSNOdysW{margin-left:8px}.aq2rbG4RYnQZUptZUhAF{word-break:break-word}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"trigger": `MPZDMG3gFfolmNtn8DPI`,
	"trigger__icon": `IkHWYU2nmo9TuxLtTJCr`,
	"triggerIcon": `IkHWYU2nmo9TuxLtTJCr`,
	"trigger__name": `B9bw3jAvOV0wDn3RjQKW`,
	"triggerName": `B9bw3jAvOV0wDn3RjQKW`,
	"trigger__label": `QQIs7Z_pgGR4_CjMyWko`,
	"triggerLabel": `QQIs7Z_pgGR4_CjMyWko`,
	"trigger__label--placeholder": `wzxtStXdtQMIQb_kmMl0`,
	"triggerLabelPlaceholder": `wzxtStXdtQMIQb_kmMl0`,
	"phoneFieldContainer": `_uKC6eBPRggz6ui2_cDc`,
	"loaderTrigger": `BxbHM9wrsiIuNRsq3OsD`,
	"loader": `x5D0hhrY0_hTi5l5FOpM`,
	"noResult": `gS7udETJ_AcjzWsEEsP1`,
	"integrationLabel": `wqG72rBtGGYfzuMJj4IP`,
	"iconGap": `ja7rU_DZj7gygSNOdysW`,
	"tooltipText": `aq2rbG4RYnQZUptZUhAF`
};
export default ___CSS_LOADER_EXPORT___;
